import(/* webpackMode: "eager" */ "/home/jetrails/pwa.awbridal.com/html/node_modules/.pnpm/next@14.2.35_@babel+core@7.26.10_react-dom@18.2.0_react@18.2.0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/jetrails/pwa.awbridal.com/html/node_modules/.pnpm/sonner@1.7.4_react-dom@18.2.0_react@18.2.0/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/home/jetrails/pwa.awbridal.com/html/src/app/global.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jetrails/pwa.awbridal.com/html/src/components/Adapter/adapter.js");
